import { TabService } from './app/tabs/services/tab.service';
import { Injectable } from '@angular/core';
import { Route, Router, RouterStateSnapshot } from '@angular/router';
import { Subject } from 'rxjs';
import { RouterService } from './app/core/router/router.service';
import { AuthService } from './app/core/services/auth/auth.service';

@Injectable()
export class GlobalEventDistributor {

    public subscriber: Subject<any> = new Subject<any>();

    id: Date = new Date();

    stores: any[];

    constructor(
        private routerService: RouterService,
        public authService: AuthService,
        private tabService: TabService,
        private router: Router) {
        this.stores = [];
    }

    registerStore(store) {
        this.stores.push(store);
    }

    registerRoutes(routes: Route[], baseHref: string) {
        this.routerService.registerRoutes(routes, baseHref);
    }

    mappingRoutes(routes: Route[], baseHref: string) {
        this.routerService.mappingRoutes(routes, baseHref);
    }

    dispatch(event: any, payload?: any) {
        if (event && event.type) {
             switch (event.type) {
                /*** PAYLOAD(UNAUTHORIZED)
                *   URL?: RedirectUrl
                *   user?: user
                */
                case 'AUTHORIZED': {
                    window.open(payload.url, '_self');
                    break;
                }
                 /*** PAYLOAD(UNAUTHORIZED)
                 *   URL?: RedirectUrl
                 */
                case 'UNAUTHORIZED': {
                    this.router.navigate(['authentication','login'], { queryParams: { 'returnUrl': payload.url}} );
                    break;
                }
                case 'ERROR_401': {
                    this.router.navigate(['error', '401']);
                    break;
                }
                case 'ERROR_403': {
                    this.router.navigate(['error', '403']);
                    break;
                }
                case 'ERROR_404': {
                    this.router.navigate(['error', '404']);
                    break;
                }
                case 'ERROR_500': {
                    this.router.navigate(['error', '500']);
                    break;
                }
                case 'DELETE_TAB': {
                  this.tabService.removeTab(event.index);
                  break;
                }

                default:
                    break;
            }
        }

        this.subscriber.next({ type: event.type, payload: payload });
        this.stores.forEach((s) => s.dispatch(event));

    }
}
